<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1800">
          <users-reports-configuration-form
            :reportsConfiguration="reportsConfiguration"
            ref="getReports"
            :plans="userPlans"
            @save="save"
            @close="close"
            :existingReportsTypes="existingReportsTypes"
            :user="user"
            :roles="roles"
          ></users-reports-configuration-form>
        </v-dialog>
        <v-dialog
          v-model="dialogs.delete"
          scrollable
          persistent
          max-width="400"
        >
          <material-card
            :title="
              $t('components.usersreportsconfigurations.delete')
            "
            :color="$vuetify.theme.themes.light.error"
            icon="remove"
          >
            <v-card-text>{{
              $t("globals.are_you_sure")
            }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color
                text
                @click="dialogs.delete= false"
                >{{ $t("globals.cancel") }}</v-btn
              >
              <v-btn color="error" text @click="tryDelete">
                {{ $t("globals.remove") }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
      </v-row>
    </v-container>
    <pbas-data-table
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      :floatActions="floatActions"
      :rowActions="rowActions"
      fileNamePrefix="usersReportsConfiguration"
      identifier="usersReportsConfiguration"
      @error="error = $event"
    ></pbas-data-table>

    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import UsersReportsHeaders from "../headers/UsersReports";
import ErrorHandler from "../components/ErrorHandler";
import UsersReportsConfigurationForm from "../components/UsersReportsConfigurationForm";
import { translate2 } from "../trans2";

export default {
  name: "users-reports-configuration",
  components: {
    ErrorHandler,
    UsersReportsConfigurationForm,
  },
  props: ["user", "roles"],
  data() {
    return {
      existingReportsTypes:{},
      userPlans: [],
      reportsConfigurations: [],
      coverageGroupItems: [],
      valid: false,
      reportsConfiguration: null,
      dialogs: {
        edit: false,
        delete: false,
      },
      error: null,
      saving: false,
      provider: undefined,
      headers: UsersReportsHeaders,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) =>
            item.Id ? this.edit(item.Id) : this.edit(item.ReportParameters.Identifier),
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => this.delete(item),
        },
      ],
      floatActions: [
        {
          name: "add",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => this.edit(),
        },
      ],
    };
  },
  async mounted() {
    try {
      const reportsConfigurationsResponse = await this.getUserReportsConfigurations(
        { userId: this.user.Id }
      );
      if (
        reportsConfigurationsResponse !== null &&
        reportsConfigurationsResponse !== undefined &&
        reportsConfigurationsResponse.status === 200
      ) {
        this.reportsConfigurations = reportsConfigurationsResponse.data;
      } else {
        this.reportsConfigurations = [];
      }

      console.log(this.reportsConfigurations, this.user, this.roles);

      this.provider = new InMemoryProvider(
        this.reportsConfigurations,
        this.headers
      );
      this.userPlans = this.user.Plans;
      this.createExistingReportsTypesDictionary();
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    ...mapActions("transactions", ["getUserReportsConfigurations"]),
    isValid() {
      return this.reportsConfigurations && this.reportsConfigurations.length > 0;
    },
    edit(id) {
      this.dialogs.edit = true;
      this.$nextTick(()=>{
        if (id !== null && id !== undefined) {
          console.log("asdsdsd")
          this.reportsConfiguration = this.reportsConfigurations.filter(
            (o) => o.Id === id || o.Identifier === id
          )[0];
        } else {
          console.log("asdsdsd33333333")
          this.reportsConfiguration = {
            ReportParameters:{
              Identifier: Math.random(),
              Options: [],
              IncludeTotal: true,
              Employers: [],
              TrustFunds: [],
              Stores: [],
              InsuranceCarriers: [],
              CoverageGroups: []
            }
          };
        }
      })
    },
    delete(item) {
      this.reportsConfiguration = item;
      this.dialogs.delete = true;
    },
    tryDelete() {
      if (this.reportsConfiguration.Id !== null && this.reportsConfiguration.Id !== undefined) {
        const index = this.reportsConfigurations.indexOf(
          this.reportsConfigurations.filter((o) => o.Id === this.reportsConfiguration.Id)[0]
        );
        this.reportsConfigurations.splice(index, 1);
      } else if (
        this.reportsConfiguration.Identifier !== null &&
        this.reportsConfiguration.Identifier !== undefined
      ) {
        const index = this.reportsConfigurations.indexOf(
          this.reportsConfigurations.filter(
            (o) => o.Identifier === this.reportsConfiguration.Identifier
          )[0]
        );
        console.log(index, this.existingReportsTypes);
        if (index > -1) {
          this.reportsConfigurations.splice(index, 1);
        }
      }
      this.createExistingReportsTypesDictionary();
      this.provider.items = this.reportsConfigurations;
      this.$refs.table.getDataAsync();
      this.dialogs.delete = false;
      this.$emit("valid-changed",true);
    },
    save(payload) {
      console.log(payload);
      if (payload.Id !== null && payload.Id !== undefined) {
        const index = this.reportsConfigurations.indexOf(
          this.reportsConfigurations.filter((o) => o.Id === payload.Id)[0]
        );
        this.reportsConfigurations[index] = payload;
      } else if (
        payload.ReportParameters.Identifier !== null &&
        payload.ReportParameters.Identifier !== undefined
      ) {
        const index = this.reportsConfigurations.indexOf(
          this.reportsConfigurations.filter(
            (o) => o.ReportParameters.Identifier === payload.ReportParameters.Identifier
          )[0]
        );
        console.log(index, this.existingReportsTypes);
        if (index > -1) {
          this.reportsConfigurations[index] = payload;
        } else {
          this.reportsConfigurations.push(payload);
        }
      }
      console.log(this.reportsConfigurations);
      this.createExistingReportsTypesDictionary();
      this.provider.items = this.reportsConfigurations;
      this.$refs.table.getDataAsync();
      this.close();
      this.$emit("valid-changed",this.reportsConfigurations.length > 0);
    },
    createExistingReportsTypesDictionary() {
      this.existingReportsTypes = {};
      for (let rc of this.reportsConfigurations) {
        if (this.existingReportsTypes[rc.PlanId] === null || this.existingReportsTypes[rc.PlanId] === undefined) {
          this.existingReportsTypes[rc.PlanId] = [rc.ReportParameters.ReportType];
        } else {
          this.existingReportsTypes[rc.PlanId].push(rc.ReportParameters.ReportType);
        }
      }
    },
    close() {
      this.reportsConfiguration = null;
      this.$nextTick(()=>{
        this.dialogs.edit = false;
      });
    },
  },
};
</script>
